import styled, { css } from 'styled-components'
import { shimmerAnim } from '../../../../utils'

type StyledProps = {
  $loading?: boolean
}

const StyledCoursePreviewIncludes = styled.section<StyledProps>`
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[200]};

  ul {
    list-style-type: none;
    padding: 0;
    display: grid;
    gap: 16px;
    margin: 24px 0 0 0;

    li {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.color.gray[700]};

      svg {
        height: 20px;
        width: 20px;
        margin-right: 10px;
      }
    }
  }

  ${({ $loading }) =>
    $loading &&
    css`
      ul {
        li {
          div {
            height: 20px;
            width: 100%;
            max-width: 100%;
            border-radius: 6px;
            animation: ${shimmerAnim} 1.4s ease-in-out infinite;
          }
        }
      }
    `}
`

export default StyledCoursePreviewIncludes
